// extracted by mini-css-extract-plugin
export default {"container":"_21Mwq","link":"_21sRj","term":"_3ZVR4"};